import dayjs from './DayjsUtil'
/**
 * @description Calcula la duración entre dos fechas en días
 *
 * @author ana.carrasco  Hábil MX
 * @version 1.0.0, 20/12/2022
 * @param fechaEmision  Fecha inicial de un evento
 * @param fechaVencimiento  Fecha final de un evento
 * @returns duracion en dias en numero entero
 */
export const calcularDuracionEnDias = (fechaEmision: string, fechaVencimiento: string | null) => {

  let duracionDias = 0
  if (fechaEmision && fechaVencimiento) {
    // La duracion se usa como dato funcional derivado para autorizaciones con fechas definidas.
    const fechaEmisionDayjs = dayjs(fechaEmision)
    const fechaVencimientoDayjs = dayjs(fechaVencimiento)
    duracionDias = Math.floor(fechaVencimientoDayjs.diff(fechaEmisionDayjs) / 60 / 60 / 24 / 1000)
  }
  return duracionDias
}
